<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-align: center;">I would like to acknowledge the influence that Bob Marley and his music had on my life and this work. His music spoke of the aspirations of an oppressed people. I tried to capture some of that emotion in my stories.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?36970fd8